import { RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import "./SelfCampaignPrimaryCta.scss";

type SelfCampaignPrimaryCtaMode = "inline" | "mobile-sticky" | "responsive-footer";
type SelfCampaignPrimaryCtaSize = "default" | "large";

type SelfCampaignPrimaryCtaProps = {
  disabled?: boolean;
  label: string;
  mode: SelfCampaignPrimaryCtaMode;
  onClick: () => void;
  size?: SelfCampaignPrimaryCtaSize;
};

const SelfCampaignPrimaryCta: React.FC<SelfCampaignPrimaryCtaProps> = ({
  disabled,
  label,
  mode,
  onClick,
  size = "default",
}) => {
  return (
    <div
      className={`self-campaign-primary-cta self-campaign-primary-cta--${mode} self-campaign-primary-cta--${size}`}
    >
      <Button type="primary" onClick={onClick} disabled={disabled}>
        <span>{label}</span>
        <RightOutlined />
      </Button>
    </div>
  );
};

export default SelfCampaignPrimaryCta;
